import { DomainBranding } from '@rygen/rygen-ui/model';

import { Contact } from '../Contact';
import { ShipmentTrackingSummary } from '../shipment/ShipmentTrackingSummary';

export class OrderTrackingSummary {
  id?: number;
  domainBranding?: DomainBranding;
  contact?: Contact;
  shipments: ShipmentTrackingSummary[] = [];

  constructor(opts?: Partial<OrderTrackingSummary>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.domainBranding != null) {
      this.domainBranding = new DomainBranding(opts.domainBranding);
    }
    if (opts?.contact != null) {
      this.contact = new Contact(opts.contact);
    }
    if (opts?.shipments != null) {
      this.shipments = opts.shipments.map(
        (val) => new ShipmentTrackingSummary(val),
      );
    }
  }
}
